import { createDomain } from 'effector';

import api from 'api';

const domain = createDomain('api/users');

const UsersFxs = {
    changePasswordFx: domain.effect(api.users.changePassword),
    checkEmailAvailableFx: domain.effect(api.users.checkEmailAvailable),
    logoutUserFx: domain.effect(api.users.logoutUser),
    searchParticipantsFx: domain.effect(api.users.searchParticipants),
    sendPasswordChangedEmailFx: domain.effect(api.users.sendPasswordChangedEmail),
    stopWorkingOnBehalfFx: domain.effect(api.users.stopWorkingOnBehalf),
    trackCurrentSectionFx: domain.effect(api.users.trackCurrentSection),
    setPasswordIsStrongFx: domain.effect(api.users.setPasswordIsStrong),
};

export default UsersFxs;
